import _ from 'underscore';

import getUrlBuilders from './url-builder';
import * as UrlHelper from './url-helper';
import type { UrlHelpersOptions, UrlHelpersResult } from './types';

const getUrlHelpers = ({
  ccBaseUrl,
  FwLinkBaseUrl,
  CampaignAzureDomain,
  cid,
  uid,
}: UrlHelpersOptions): UrlHelpersResult => ({
  ..._.omit(UrlHelper, 'getTermsAndConditionsUrl'),
  TermsAndConditionsUrl: UrlHelper.getTermsAndConditionsUrl(ccBaseUrl),
  getForwardLink: _.partial(UrlHelper.getForwardLink, FwLinkBaseUrl),
  getErrorPageUrl: _.partial(UrlHelper.getErrorPageUrl, ccBaseUrl),
  getSAPApplicationSupportingDocumentUrl: _.partial(UrlHelper.getSAPApplicationSupportingDocumentUrl, ccBaseUrl, cid, uid),
  getAccountTaxCertificationUrl: _.partial(UrlHelper.getAccountTaxCertificationUrl, ccBaseUrl, cid, uid),
  getCampaignPageUrl: _.partial(UrlHelper.getCampaignPageUrl, CampaignAzureDomain),
}) as UrlHelpersResult;

export {
  getUrlBuilders,
  getUrlHelpers,
  UrlHelper,
};

export type {
  BaseUrlBuilderClass,
  BaseUrlBuilderInstance,
  GetUrlBuildersOptions,
  GetUrlMethod,
  UriInstance,
  UrlBuilderClass,
  UrlBuilderConfig,
  UrlBuilderInstance,
  UrlBuildersResult,
  UrlContextFetcher,
  UrlHelpersOptions,
  UrlHelpersResult,
  UrlQueryParams,
  UrlQueryValue,
} from './types';
